import Router  from './component/routes/Router';
import './App.css';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";


function App() {
  return (
  <>

  <div>
  <Router />
  </div>
  </>
  );
}

export default App;
